import { z } from "zod";

export const CreateChannelBodyPayloadSchema = z.object({
	name: z.string().min(1, "Name should be filled"),
	messageable_id: z.string(),
	messageable_type: z.enum(["User"]),
});

export type CreateChannelBodyPayloadSchema = z.infer<
	typeof CreateChannelBodyPayloadSchema
>;
